
import "./Navbar.css";
import React, { useEffect, useState } from "react";
import Navbar from 'react-bootstrap/Navbar';
import Nav from "react-bootstrap/Nav";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Container, Button, Carousel, Card } from "react-bootstrap";
import Logo from "../Images/logo.png";
import TableMeeting from "../Images/tableMeeting.png";
import Sanlam from "../Images/sanlam.png";
import Leppard from "../Images/leppard.png";
import Hollard from "../Images/hollard.png";
import LogosPeople from "../Images/logosPeople.jpeg";
import TestingLogos from "../Images/TestingLogos.png";
import TestingLogos2 from "../Images/TestingLogos2.png";
import Logos3 from "../Images/Logos3.png";
import LogosMobile1 from "../Images/LogoMobile1.png";
import Team1 from '../Images/rianbotes.png';
import Team2 from '../Images/CharlesSkinner.png';
import Team3 from '../Images/InaLeRoux.jpeg'

import Businessman from "../Images/businessman.svg"
import HandShake from "../Images/handShake.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faCarSide, faEnvelope, faHospital, faJetFighterUp, faMagnifyingGlassChart, faMapMarkerAlt, faPhone, faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { QuoteBlock } from "./QuoteBlock";
import { Hero } from "./Hero";
import { ServiceCard } from "./ServiceCard";
import bluePurpleBackground from "../Images/bluePurpleBackground.png"
import DeskPapers from "../Images/DeskPapers.jpg"
import ReactGA from "react-ga4";

export const HomePage = () => {

  ReactGA.initialize("G-ECGH6LJ63Y");
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  const servicesRowOne = [
    {
      icon: faCarSide,
      title: "Personal & Short Term Insurance",
      description: "Car, Home, Personal Assets",
      link: "/PersonalInsurance"
    },
    {
      icon: faBriefcase,
      title: "Commercial Insurance",
      description: "Manufacturing, Business, Body Corporate, Hospitality",
      link: "/CommercialBusinessInsurance"
    },
    {
      icon: faUserDoctor,
      title: "Medical Malpractice",
      description: "For Health Practitioners",
      link: "/MedicalMalpractice"
    },
    {
      icon: faHospital,
      title: "Health",
      description: "Medical Aids, Health Insurance, Gap Cover",
      link: "/HealthInsurance"
    }
  ];

  const servicesRowTwo = [{
    icon: faJetFighterUp,
    title: "Special Risks",
    description: "Drones, Events, Cyber, Engineering",
    link: "/SpecialRisk"
  },
    // {
    //   icon: faMagnifyingGlassChart,
    //   title: "Life & Investment",
    //   description: "Long Term Financial Planning & Group Schemes",
    //   link: "/LifeAndInvestment"
    // }
  ];

  const partnerLogos = [
    { src: { Sanlam } },
    { src: { Sanlam } },
    { src: { Sanlam } },
    { src: { Sanlam } },
    // Add more logos as needed
  ];
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Listen for window resize events
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <>

      <Hero
        logoImage={Logo}
        backgroundImage={DeskPapers}
        headerText="We understand the complexities of insurance so that you don't have to. "
        subheaderText="We care deeply about our customers and deliver a service that is personal and affordable." />



      <Container fluid className="my-5 m-0" style={{ padding: '2rem' }}>
        <h1 className="text-center mb-4" style={{ color: "orange", paddingTop: '1rem', paddingBottom: '1rem' }}>
          Our Business Services
        </h1>
        <Row className="m-0" xs={1} sm={2} md={3} lg={4}>
          {servicesRowOne.map((service, index) => (
            <Col className="mb-4" key={index}>
              <ServiceCard
                icon={service.icon}
                title={service.title}
                description={service.description}
                link={service.link}
              />
            </Col>
          ))}
        </Row>
        <Row xs={1} sm={2} md={3} lg={4} className="g-4 justify-content-center" style={{ paddingTop: '1rem' }}>
          {servicesRowTwo.map((service, index) => (
            <Col className="mb-4" key={index}>
              <ServiceCard
                icon={service.icon}
                title={service.title}
                description={service.description}
                link={service.link}
              />
            </Col>
          ))}
        </Row>
      </Container>


      <QuoteBlock description="Our added value to your cover is that of integrity, personal attention and dependable service at all times." />



      <Container fluid style={{ padding: '0' }}>


        <Row className="align-items-center mb-5" style={{ backgroundColor: '#ffffff', padding: '2rem', borderRadius: '10px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)' }}>
          <Col md={6}>
            <h2 style={{ fontSize: '2rem', color: 'orange' }}>Why do I need a broker?</h2>
            <h4
              style={{
                fontSize: '1.375rem', // Subheading size
                fontWeight: 500,
                color: '#495057', // Softer gray for secondary text
                marginBottom: '1.5rem',
              }}
            >
              Logos can help you find the cover you need because we understand the risks involved. We want to help clients understand exactly what they are covered for.
            </h4>
            <p
              style={{
                fontSize: '1rem',
                color: '#6c757d', // Muted text color for readability
                lineHeight: '1.8', // Relaxed line spacing for readability
                textAlign: 'justify',
                marginBottom: '1.5rem',
              }}
            >
              Insurance for most people remain a grudge purchase. Should life happen however, being insured correctly helps to ease the pain and frustration that comes with disasters. The purpose of insurance is to help you back on your feet as quickly as possible. In this process your broker will stand by you and guide you through the pitfalls. The do's and dont's. Gremlins that cause frustration and delays.
              <br /><br />

              <div
                style={{
                  textAlign: 'center',
                  marginTop: '2rem',
                  marginBottom: '2rem',
                  padding: '1rem',
                  fontStyle: 'italic',
                  fontSize: '1.1rem',
                  color: '#1e1e3f',
                  lineHeight: '2',
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))',
                  borderRadius: '15px',
                  maxWidth: '700px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                }}
              >
                <p style={{ margin: '0.5rem 0' }}>Understand your cover.</p>
                <p style={{ margin: '0.5rem 0' }}>Be insured correctly.</p>
                <p style={{ margin: '0.5rem 0' }}>Have a financial guide to the rocky road of unknowns.</p>
                <p style={{ margin: '0.5rem 0' }}>If you don't know, you will be shocked.</p>
                <p style={{ margin: '0.5rem 0' }}>If you know, you will be prepared.</p>
                <p style={{ margin: '0.5rem 0' }}>Know your broker.</p>
                <p style={{ margin: '0.5rem 0' }}>He is there to help you.</p>
              </div>

            </p>
          </Col>
          <Col md={6} className="text-center">
            <h3
              style={{
                color: '#1e1e3f',
                fontWeight: 600,
                marginBottom: '2rem',
              }}
            >
              Our Team
            </h3>

            <div
              style={{
                display: 'flex',
                gap: '2rem',
                flexWrap: 'wrap',
                justifyContent: 'center',
              }}
            >
              {[
                { img: Team1, name: 'Rian Botes' },
                { img: Team2, name: 'Charles Skinner' },
                { img: Team3, name: 'Ina le Roux' },
              ].map((member, index) => (
                <div key={index} style={{ textAlign: 'center' }}>
                  <div
                    style={{
                      width: '140px',
                      height: '140px',
                      borderRadius: '50%',
                      overflow: 'hidden',
                      boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                      border: '4px solid #ffffff',
                      marginBottom: '0.75rem',
                    }}
                  >
                    <img
                      src={member.img}
                      alt={member.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </div>

                  <div
                    style={{
                      fontSize: '1rem',
                      fontWeight: 500,
                      color: '#495057',
                    }}
                  >
                    {member.name}
                  </div>
                </div>
              ))}
            </div>
          </Col>

        </Row>
      </Container>

      {/* <Card className="carousel-card">
        <Carousel interval={3000} indicators={false}>
          <Carousel.Item>
            <img
              src={isMobile ? LogosMobile1 : TestingLogos}
              alt="Partner 1"
              className="d-block w-100"
              style={{ objectFit: 'contain', height: '200px' }} // Ensures the image fits within a fixed height without distortion
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              src={isMobile ? TestingLogos2 : TestingLogos2}
              alt="Partner 2"
              className="d-block w-100"
              style={{ objectFit: 'contain', height: '200px' }} // Ensures the image fits within a fixed height without distortion
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              src={isMobile ? Logos3 : Logos3}
              alt="Partner 2"
              className="d-block w-100"
              style={{ objectFit: 'contain', height: '200px' }} // Ensures the image fits within a fixed height without distortion
            />
          </Carousel.Item>
        </Carousel>
      </Card> */}



    </>
  );
}



